export default __webpack_public_path__ + "static/media/watch-disabled.06655971.svg";